//jqueryFree
export default function () {

    //Přidá počítadlo znaků textovému inputu
    //Html musí mít předpřipravenou správnou strukturu:
    //<div class="input-text-number-chars-container">
    //<input class="input-text-number-chars" ....>
    //<div class="count-chars">Znaků: <span class="number-chars"></span><span class="max-limit"></span></div>
    //</div>
    //
    // pokud jsou inputy ve snippetu / dochazi k jejich prekresleni, tak je potreba pri tom spoustet:
    // if(window.hasOwnProperty('commonUtilsRefresh')){
    //      window.commonUtilsRefresh();
    // }
    // aby se doplnil event na input

    const recountInput = (input) => {
        let maxLimit = input.getAttribute('maxlength');
        let maxLimitVal = '';
        if (maxLimit > 0) {
            maxLimitVal = '/' + maxLimit;
        }
        let isValCount = input.value.length;
        let countChars = input.nextElementSibling.querySelector('.number-chars');
        let maxLimitElement = input.nextElementSibling.querySelector('.max-limit');
        if ((!countChars instanceof Element) || (!maxLimitElement instanceof Element)) {
            console.warn("missing element(s) for CommonUtils");
        }
        countChars.textContent = isValCount;
        maxLimitElement.textContent = maxLimitVal;
    }

    function countCharacters() {
        let inputs = document.querySelectorAll('.input-text-number-chars');
        inputs.forEach(function (_input) {

            _input.addEventListener('input', function (event) {
                let input = event.currentTarget;
                recountInput(input);
            });

            recountInput(_input);
        });
    }

    // Přepočítat znaky při načítání stránky
    countCharacters();

}
